import { pickBy } from 'lodash-es';

const getCleanedUrlParams = (params) => {
  return pickBy(
    params,
    (item) => item !== null && item !== undefined && item !== ''
  );
};

export default getCleanedUrlParams;
